<div class="proxy-settings">
    <div class="proxy">
    <div class="proxy-item " *ngIf="parent === 'monitor'">
        <div class="proxy-item-wrapper" (click)="_onClick('Default')" [ngClass]="{'selected-proxy' : webProxyOption === 'Default'}" >
          <div class="proxy-icon" [ngClass]="{'selected-icon' : webProxyOption === 'Default'}"><mat-icon>check_circle_outline</mat-icon></div>
          <div class="proxy-item-content">
            <div class="label column">Default</div>
            <div class="description">Use proxy configured at the originator</div>
            <div class="description sub-desc" *ngIf="defaultProxyURL !== ''" class="label">{{defaultProxyURL}}</div>
          </div>
        </div>
      </div>
      <div class="proxy-item">
        <div class="proxy-item-wrapper" (click)="_onClick('None')" [ngClass]="{'selected-proxy' : webProxyOption === 'None'}">
          <div class="proxy-icon"  [ngClass]="{'selected-icon' : webProxyOption === 'None'}"><mat-icon>check_circle_outline</mat-icon></div>
          <div class="proxy-item-content">
            <div class="label column">None</div>
            <div class="description">Do not use a proxy</div>
          </div>
        </div>
      </div>

      <div class="proxy-item">
        <div class="proxy-item-wrapper" (click)="_onClick('Custom')" [ngClass]="{'selected-proxy' : webProxyOption === 'Custom'}">

          <div class="proxy-icon" [ngClass]="{'selected-icon' : webProxyOption === 'Custom'}"><mat-icon>check_circle_outline</mat-icon></div>
          <div class="proxy-item-content">
            <div class="label column">Custom
            <div class="description">Configure a proxy for this {{(parent === 'monitor')?'active test':'agent'}}</div>
            </div>

          <div class="proxyCustomForm" *ngIf="webProxyOption === 'Custom'">
            <form name="form" >
              <div class="group">
                <!---
                <p>Protocol</p>
                <select ng-disabled="true" (ngModelChange)="_onClick('Custom')" class="alias disabled-select" name="type"  [(ngModel)]="protocol" aria-invalid="false">
                  <option value="http">HTTP</option>
                  <option value="https">HTTPS</option>
                </select>
                -->
                <span class="proxy-string"><span class="proxy-label">Proxy URL: </span>{{protocol}}://{{address}}:{{port}}</span>
              </div>
              <div class="group">
                <p>Server *</p>
                <input
                      autocomplete="off"
                      placeholder="domain name or address"
                      (ngModelChange)="_onClick('Custom')"
                      class="alias"
                      [(ngModel)]="address"
                      name="address"
                      #addressInput="ngModel"
                      required
                      maxlength="50"
                      [pattern] = "validAddressRegex"/>
                <div class="error" *ngIf="addressInput.invalid && (addressInput.dirty || addressInput.touched)">
                  <mat-error *ngIf="addressInput.errors.maxlength">Address is too long.</mat-error>
                  <mat-error *ngIf="addressInput.errors.required">Address is required.</mat-error>
                  <mat-error *ngIf="addressInput.errors.pattern">Address is invalid.</mat-error>
                </div>
              </div>

              <div class="group">
                <p>Port</p>
                <input type="number"
                      autocomplete="off"
                      (ngModelChange)="_onClick('Custom')"
                      name="port"
                      class="alias"
                      #portInput="ngModel"
                      [(ngModel)]="port"
                      maxlength="5"
                      min="1"
                      max="65535"
                     />
                <div class="error" *ngIf="portInput.invalid && (portInput.dirty || portInput.touched)">
                  <mat-error *ngIf="portInput.errors.min">Port range should be 1 to 65535.</mat-error>
                  <mat-error *ngIf="portInput.errors.max">Port range should be 1 to 65535.</mat-error>
                </div>
              </div>
            </form>
          </div>
         </div>
        </div>
      </div>
    </div>
</div>
